@if (isOpen) {
  <div class="image-popup" (click)="closeModal()">
    <div class="modal-content" (click)="closeModal()" [@imageAnimation]>
      <div class="image-container">
        <img #modalImage [src]="imageSrc" [alt]="imageAlt" (click)="closeModal()" alt="" draggable="false">
      </div>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>
  </div>
}